// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__Hct9h","center":"styles_center__6Hb96","iconWrapper":"styles_iconWrapper__L_M_V"};